/** @file panelRegistry: the panel components the screens mount. */
import type { ComponentType } from 'react';
import { ArtScreen } from '../panels/art/ArtScreen';
import { Inspector } from '../panels/inspector/Inspector';
import { Timeline } from '../panels/timeline/Timeline';
import { NodeTree } from '../panels/tree/NodeTree';
import { Viewport } from '../panels/viewport/Viewport';

/** Every panel slot; the viewport also takes its mode (`edit` on Pose, `turntable` on Art). */
export type PanelRegistry = {
  viewport: ComponentType<{ mode: 'edit' | 'turntable' }>;
  nodeTree: ComponentType;
  inspector: ComponentType;
  timeline: ComponentType;
  artSlots: ComponentType;
};

/** A panel slot id. */
export type PanelId = keyof PanelRegistry;

/** The real panels (T-503, T-504, T-505). */
export const panelRegistry: PanelRegistry = {
  viewport: Viewport,
  nodeTree: NodeTree,
  inspector: Inspector,
  timeline: Timeline,
  artSlots: ArtScreen,
};
